import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  connect() {
    this.update()
    this._onResize = this.update.bind(this)
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    this.disposeTooltip()
    window.removeEventListener("resize", this._onResize)
  }

  update() {
    // clean up any existing tooltip
    this.disposeTooltip()

    // force layout calculation
    if (this.element.scrollWidth > this.element.clientWidth) {
      this.enableTooltip()
    }
  }

  enableTooltip() {
    this.element.setAttribute("title", this.textValue)
    this.element.setAttribute("data-bs-toggle", "tooltip")

    this.tooltip = new bootstrap.Tooltip(this.element)
  }

  disposeTooltip() {
    if (this.tooltip) {
      this.tooltip.dispose()
      this.tooltip = null
    }

    this.element.removeAttribute("title")
    this.element.removeAttribute("data-bs-toggle")
  }
}
